<template>
  <div class="customer-detail">
    <div class="customer-header pt-0">
      <slot name="header"></slot>

      <div class="text-xs-center">
        <v-avatar size="100">
          <v-img
            :lazy-src="group_id ? user.group_picture_url : user.profile_pic"
            :src="
              group_id
                ? user.group_picture_url || '/static/img/assets/livechat/profile.png'
                : user.profile_pic || '/static/img/assets/livechat/profile.png'
            "
            aspect-ratio="1"
            class="grey lighten-2"
          >
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
        </v-avatar>
        <div v-if="!group_id" class="text-xs-center mt-2" style="color: white">
          {{ user.first_name ? user.first_name : '' }} {{ user.last_name ? user.last_name : '' }}
        </div>
        <div v-else class="text-xs-center mt-2" style="color: white">
          {{ user.group_name ? user.group_name : '' }}
        </div>

        <p class="px-3 py-1" v-if="!group_id">
          <template v-if="!isEditNickname">
            <span style="color:#cecece">{{ customerNickname }}</span>
            <a style="color:white" href="javascript:void(0);" @click="isEditNickname = true">
              <span class="fas fa-pencil-alt"></span>
            </a>
          </template>
          <template v-else>
            <div class="form-control">
              <input
                type="text"
                class="form-control"
                :placeholder="placeholder"
                v-model="customerNickname"
                small
                maxlength="600"
              />
            </div>
            <div class="text-xs-center">
              <v-btn depressed color="primary" small @click="cancelEdit">{{ $t('cancel') }}</v-btn>
              <v-btn outline color="white" small @click="saveEdit">{{ $t('Save') }}</v-btn>
            </div>
          </template>
        </p>
        <div class="mb-4 text-xs-center" style="display: flex; place-content: center;">
          <v-btn
            :href="'https://business.facebook.com' + user.inboxurl"
            target="_blank"
            small
            depressed
            round
            color="#3b5998"
            dark
            v-if="user.app == 'facebook' && user.inboxurl"
          >
            <i class="fab fa-facebook-square mr-1"></i>
            {{ $t('View inbox') }}
          </v-btn>
          <template>
            <v-btn
              @click="goToAllInOneChat"
              small
              :disabled="!user.id"
              depressed
              round
              outline
              dark
              v-if="$route.name !== 'allinonechat'"
            >
              <v-icon class="mr-1" small>chat</v-icon>
              {{ $t('All in one chat button') }}
            </v-btn>
          </template>
          <template v-if="selectedBot.theme == 'ecommercebasic' && !selectedBot.useketshop">
            <template v-if="!group_id">
              <div style="display: flex;">
                <v-btn
                  small
                  :loading="loadingCreatebill"
                  depressed
                  outline
                  dark
                  @click.stop="shoplink('oldVersion')"
                  style="display: inline-block; margin-right: -1px; border-radius: 15px 0px 0px !important;"
                >
                  <v-icon class="mr-1">shopping_cart</v-icon> {{ $t('create_order') }}
                </v-btn>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      v-on="on"
                      class="ml-0"
                      style="display: inline-block; border-radius: 0 ;
                          color: white !important;
                          border-radius: 0px 20px 20px 0px !important"
                      outline
                      icon
                    >
                      <v-icon>arrow_drop_down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile @click.stop="shoplink('newVersion')">
                      <v-list-tile-title> {{ $t('new_create_order') }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </div>
            </template>
            <template v-else>
              <v-btn
                :disabled="is_leave_group || is_blocked ? true : false"
                @click="
                  {
                    dialogMember = true
                    isCreateBill = true
                  }
                "
                small
                depressed
                round
                outline
                dark
              >
                <v-icon class="mr-1" small>shopping_cart</v-icon>
                {{ $t('create_order') }}
              </v-btn>

              <template>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      depressed
                      round
                      outline
                      dark
                      color="white"
                      v-on="on"
                      :disabled="is_leave_group ? true : false"
                    >
                      <v-icon class="mr-1" small>settings</v-icon> {{ $t('Setting group') }}
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile v-if="!is_blocked" @click="blockGroup('block')">
                      <v-list-tile-title>
                        <i class="fa fa-lock mr-1"></i>
                        {{ $t('Block') }}</v-list-tile-title
                      >
                    </v-list-tile>
                    <v-list-tile v-if="is_blocked" @click="blockGroup('unblock')">
                      <v-list-tile-title
                        ><i class="fa fa-unlock mr-1"></i> {{ $t('Unblock') }}</v-list-tile-title
                      >
                    </v-list-tile>
                    <v-list-tile v-if="!isModular(group_id)" @click="leaveGroup()">
                      <v-list-tile-title>
                        <i class="fa fa-sign-out mr-1"></i>
                        {{ $t('Leave group') }}</v-list-tile-title
                      >
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </template>
            </template>
          </template>
        </div>
      </div>
    </div>
    <template v-if="!loading">
      <v-dialog v-model="dialogMember" scrollable max-width="300px">
        <v-card>
          <v-toolbar color="primary" dark>
            <v-toolbar-title v-if="isCreateBill">เลือกสมาชิกกลุ่ม</v-toolbar-title>
            <v-toolbar-title v-else>สมาชิกกลุ่ม</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <div style="position: absolute; right: 5px; top: 5px;">
            <v-btn color="white" fab small flat @click="dialogMember = false">
              <v-icon>close</v-icon>
            </v-btn>
          </div>

          <v-list two-line>
            <template v-for="(item, index) in memberGroup">
              <v-divider :key="index + '_divider'"></v-divider>

              <v-list-tile :key="index + '_list'" avatar>
                <v-list-tile-avatar>
                  <img :src="item.picture_url" />
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title v-html="item.display_name"></v-list-tile-title>
                </v-list-tile-content>
                <v-btn v-if="isCreateBill" color="primary" @click="openGroupBill(item)"
                  >เลือก</v-btn
                >
              </v-list-tile>
            </template>
          </v-list>
        </v-card>
      </v-dialog>
      <v-layout wrap>
        <v-flex v-if="group_id" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <a
            class="caption"
            @click="
              {
                dialogMember = true
                isCreateBill = false
              }
            "
            >สมาชิกกลุ่ม</a
          >
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Channel') }}</label>
          <p>
            <span style="color: #3b5998" v-if="user.app == 'facebook'">
              <i class="fab fa-facebook-square"></i> Facebook
            </span>
            <span style="color: #00c300" v-else-if="user.app == 'line' || group_id">
              <i class="fab fa-line"></i> Line
            </span>
            <span style="color: #C13584" v-else-if="user.app == 'instagram'">
              <i class="fab fa-instagram"></i> Instagram
            </span>
            <span style="color: #00c300" v-else-if="user.app == 'whatsapp'">
              <i class="fab fa-whatsapp"></i> WhatsApp
            </span>
            <span class="primary--text" v-else>
              {{ user.app }}
            </span>
          </p>
        </v-flex>

        <v-flex v-if="!group_id" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('gender') }}</label>
          <p>{{ $t(user.gender) }}</p>
        </v-flex>

        <v-flex v-if="!group_id" xs12 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Locale') }}</label>
          <p>
            <template v-if="userLocale">
              <flag :iso="userLocale.icon" />
              {{ userLocale.title }}
            </template>
            <template v-else>-</template>
          </p>
        </v-flex>
        <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption">
            {{ $t('Status') }}
            <v-premium-lock :inline="true"></v-premium-lock>
          </label>
          <div>
            <p>
              <edit-customer-value
                v-model="user['status']"
                :userid="user.id"
                :placeholder="$t('Status')"
                @onEdit="onEditStatus"
                :itemOption="statusOptions"
                :multiple="false"
                :combobox="true"
              >
                <customer-item-value :value="user['status']">{{ user.status }}</customer-item-value>
              </edit-customer-value>
            </p>
          </div>
        </v-flex>
        <v-flex v-if="!group_id" xs12 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption">
            {{ $t('Address') }}
            <v-premium-lock :inline="true"></v-premium-lock>
          </label>
          <div>
            <p>
              <edit-customer-value
                v-model="user['address']"
                :userid="user.id"
                :placeholder="$t('Address')"
                @onEdit="onEditAddress"
              >
                <customer-item-value :value="user['address']">{{
                  user.address
                }}</customer-item-value>
              </edit-customer-value>
            </p>
          </div>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>

      <v-layout wrap>
        <v-flex v-if="!group_id" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Register Date') }}</label>
          <p v-if="!group_id">
            {{ user.registertimestamp ? getFormatDate(user.registertimestamp, 'DD/MM/YYYY') : '-' }}
          </p>
          <p v-else>{{ user.created_at ? getFormatDate(user.created_at, 'DD/MM/YYYY') : '-' }}</p>
        </v-flex>

        <v-flex v-if="!group_id" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Last Active Date') }}</label>
          <p v-if="!group_id">
            {{ user.timestamp ? getFormatDate(user.timestamp, 'DD/MM/YYYY') : '-' }}
          </p>
          <p v-else>
            {{
              user.last_message_timestamp
                ? getFormatDate(user.last_message_timestamp, 'DD/MM/YYYY')
                : '-'
            }}
          </p>
        </v-flex>

        <v-flex v-if="!group_id" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Email') }}</label>
          <p style="word-wrap: break-word;">
            <edit-customer-value
              v-model="user['email']"
              :userid="user.id"
              :placeholder="$t('Email')"
              @onEdit="onEditEmail"
            >
              <customer-item-value :value="user['email']">{{ user.email }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex v-if="!group_id" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('phone no.') }}</label>
          <p>
            <edit-customer-value
              v-model="user['phoneno']"
              :userid="user.id"
              :placeholder="$t('phone no.')"
              @onEdit="onEditPhone"
            >
              <customer-item-value :value="user['phoneno']">{{ user.phoneno }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Context') }}</label>
          <p>
            <edit-customer-value
              v-model="user['context']"
              :userid="user.id"
              :placeholder="$t('Context')"
              @onEdit="onEditContext"
              :comboboxCustom="true"
              :itemOption="contextOptions"
              label="label"
              trackBy="value"
              :taggable="true"
            >
              <!-- <customer-item-value :value="user['context']">{{ user.context }}</customer-item-value> -->
              <customer-item-value :value="user['context']">
                {{ user.context ? $t(user.context) : '-' }}
              </customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex xs12 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Note') }}</label>
          <p>
            <edit-customer-value
              :textarea="true"
              v-model="user['note']"
              :userid="user.id"
              :placeholder="$t('Note')"
              @onEdit="onEditNote"
            >
              <customer-item-value :value="user['note']">
                <div class="form-control">
                  <textarea
                    rows="3"
                    v-model="user['note']"
                    style="resize: vertical; width: 90%;"
                    disabled
                  ></textarea></div
              ></customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex v-if="isBU" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Line ID') }}</label>
          <p>
            <edit-customer-value
              v-model="user['lineid']"
              :userid="user.id"
              :placeholder="$t('Line ID')"
              @onEdit="onEditLineId"
            >
              <customer-item-value :value="user['lineid']">{{ user.lineid }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex v-if="isBU" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('School') }}</label>
          <p>
            <edit-customer-school
              v-model="user['school']"
              :userid="user.id"
              :placeholder="$t('School')"
              @onEdit="onEditSchool"
            >
              <customer-item-value :value="user['school']">{{ user.school }}</customer-item-value>
            </edit-customer-school>
          </p>
        </v-flex>

        <v-flex v-if="isBU" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Province') }}</label>
          <p>
            <edit-customer-value
              v-model="user['province']"
              :userid="user.id"
              :placeholder="$t('Province')"
              @onEdit="onEditProvince"
            >
              <customer-item-value :value="user['province']">{{
                user.province
              }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>

      <div class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>
          {{ $t('Tag') }}
          <v-premium-lock :inline="true"></v-premium-lock>
        </label>

        <a
          href="javascript:void(0);"
          v-if="$store.getters.getPackage == 'premium' && !isEditTag && !isCoachlab"
          @click="isEditTag = true"
        >
          <span class="fas fa-pencil-alt"></span>
        </a>
      </div>
      <div class="pl-3 pr-3 pt-2 pb-2">
        <template v-if="!isEditTag">
          <div class="left-align" v-if="tags.length == 0">{{ $t('No tag') }}</div>
          <ul class="tags">
            <li class="tag" v-for="(tag, index) in tags" :key="'usertag_' + index">
              <specialtext :text="tag"></specialtext>
            </li>
          </ul>
        </template>
        <template v-else>
          <tags
            :combobox="true"
            v-model="usertag"
            :tags="usertags"
            @tags-changed="addUserTags"
            @before-adding-tag="checkUserTags"
            :itemOption="tagOptions"
            style="margin-bottom: 5px"
            :btnText="$t('Add tag')"
          ></tags>

          <div class="text-xs-center" style="margin-top: 15px">
            <v-btn outline color="grey" small @click="cancelEditTag">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" small @click="saveEditTag">{{ $t('Save') }}</v-btn>
          </div>
        </template>
      </div>

      <v-divider></v-divider>
      <div class="pl-3 pr-3 pt-2 pb-2">
        <div class="mb-2">
          <label class="caption">
            {{ $t('Data Summary') }}
          </label>
          <a href="javascript:void(0);" v-if="!isEditSession" @click="isEditSession = true">
            <span class="fas fa-pencil-alt"></span>
          </a>
          <div
            style="width: 100%"
            href="javascript:void(0);"
            v-if="isEditSession && typeof userSession === 'object'"
          >
            <v-btn
              small
              outline
              style="width: 100%; color: #808080"
              v-if="isEditSession"
              @click="addUserSession"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </div>
        </div>
        <template>
          <div
            v-if="typeof userSession === 'object'"
            style="
              overflow-y: auto;
              max-height: 300px;
              padding: 5px;
              background: #f7f7f7;
              border: 1px solid #eee;
              border-radius: 5px;
            "
          >
            <template>
              <template>
                <div
                  :key="`key${index}`"
                  v-for="(item, index) in userDataSession"
                  style="padding: 10px; margin: 5px 0; border: 1px solid #eee; background: white"
                >
                  <v-btn
                    icon
                    v-if="isEditSession"
                    style="float: right;"
                    @click="deleteSession(userDataSession[index].key, index)"
                    ><v-icon color="primary">delete</v-icon></v-btn
                  >
                  <v-layout row wrap>
                    <v-flex xs12 sm6 class="form-control">
                      <template v-if="!isEditSession">
                        <span style="color:#FF706B">{{
                          userDataSession[index].key
                        }}</span></template
                      >
                      <input
                        style="color:#FF706B"
                        v-else
                        type="text"
                        v-model="userDataSession[index].key"
                      />
                    </v-flex>
                    <v-flex xs12 sm6 class="form-control">
                      <template v-if="!isEditSession">{{ userDataSession[index].value }}</template>
                      <input v-else type="text" v-model="userDataSession[index].value"
                    /></v-flex>
                  </v-layout>
                </div>
              </template>
            </template>
          </div>
          <div v-else>
            <p v-if="!isEditSession">{{ userSession }}</p>
            <input v-else type="text" v-model="userSession" />
          </div>
          <div class="text-xs-center mt-2" v-if="isEditSession">
            <v-btn outline color="grey" small @click="cancleEditSession">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" small @click="editSession">{{ $t('Save') }}</v-btn>
          </div>
        </template>
      </div>
      <v-divider v-if="userSession"></v-divider>
      <div v-if="!getuseronly" class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>{{ $t('Message Sent') }}</label>
        <div style="position: relative" margin-top="25">
          <div v-if="!selectedBot.status">
            <div class="text-xs-center my-3">
              <v-card
                max-width="600"
                style="margin: auto;border-radius: 10px"
                flat
                class="grey lighten-4"
              >
                <v-card-text>
                  <h2 style="text-shadow: 1px 1px 20px #9e9e9e;" class="display-1">
                    {{ $t('If you want to test, please activate your bot') }}
                  </h2>
                  <p>
                    {{
                      $t('Information will not be recorded in analytics if the bot is inactivated')
                    }}
                  </p>

                  <v-btn
                    depressed
                    style="margin-bottom:1.5em"
                    @click="toggleBotStatus"
                    small
                    color="primary"
                    >{{ $t('Click for starting your Bot') }}</v-btn
                  >
                </v-card-text>
              </v-card>
            </div>
          </div>
          <template v-else>
            <v-premium-plan-popup
              :showAll="false"
              v-if="$store.getters.getPackage != 'premium' || isCoachlab"
            ></v-premium-plan-popup>
            <div
              style="
              overflow-y: auto;
              max-height: 300px;
              padding: 5px;
              background: #f7f7f7;
              border: 1px solid #eee;
              border-radius: 5px;
            "
            >
              <template v-if="$store.getters.getPackage != 'premium' || isCoachlab">
                <div
                  v-for="(intent, index) in 10"
                  :key="'intent_' + index"
                  style="padding: 10px; margin: 5px 0; border: 1px solid #eee; background: white"
                >
                  <div
                    style="
                    height: 15px;
                    position: relative;
                    top: 3px;
                    display: inline-block;
                    width: 100%;
                    max-width: 100px;
                    background-color: #eee;
                  "
                  ></div>
                </div>
              </template>
              <template v-else>
                <template v-if="filterIntent.length > 0">
                  <div
                    v-for="(intent, index) in filterIntent"
                    :key="'intent_' + index"
                    style="padding: 10px; margin: 5px 0; border: 1px solid #eee; background: white"
                  >
                    <template v-if="$store.getters.getPackage == 'premium' && !isCoachlab">
                      <template v-if="intent.name === '{default}'">{{
                        $t('Default Conversation')
                      }}</template>
                      <template v-else-if="intent.name === '{welcome}'">{{
                        $t('Welcome Message')
                      }}</template>
                      <template v-else-if="intent.name === '{default_comment_to_inbox}'">{{
                        $t('More Comment to Inbox')
                      }}</template>
                      <template v-else-if="intent.name == null">{{ $t('Other') }}</template>
                      <template v-else>{{ intent.name }}</template>
                      ({{ intent.count | numberFormat }})
                    </template>
                  </div>
                </template>
                <template v-else>
                  <div class="text-center">{{ $t('No message sent') }}</div>
                </template>
              </template>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CustomerDetail from './CustomerDetail.js'

export default {
  mixins: [CustomerDetail]
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/CustomerDetail.vue